import type { BoxProps } from '@hover/blueprint';
import { Box, forwardRef, useMergeRefs } from '@hover/blueprint';
import React, { useEffect } from 'react';

import { useElementVisibility } from 'src/shared/hooks/useElementVisiblity';

interface VisibilityPixelProps extends BoxProps {
  onVisibleHandler: () => void;
}

const VisibilityPixel = forwardRef<VisibilityPixelProps, 'div'>(
  ({ onVisibleHandler, ...props }, ref) => {
    const [isVisibleRef, isVisible] = useElementVisibility();

    useEffect(() => {
      if (isVisible) {
        onVisibleHandler();
      }
    }, [isVisible, onVisibleHandler]);

    return (
      <Box
        key="visibility-pixel"
        position="absolute"
        testId="visibility-pixel"
        {...props}
        ref={useMergeRefs(ref, isVisibleRef)}
      >
        &nbsp;
      </Box>
    );
  },
);

export { VisibilityPixel };
